var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.$i18n.locale == 'zh-CN')?_c('home-zh',{ref:"homeZh"}):_vm._e(),(_vm.$i18n.locale == 'en-US')?_c('home-en',{ref:"homeEn"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }